import { render, staticRenderFns } from "./ClipboardInput.vue?vue&type=template&id=7007721d&"
import script from "./ClipboardInput.vue?vue&type=script&lang=js&"
export * from "./ClipboardInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7007721d')) {
      api.createRecord('7007721d', component.options)
    } else {
      api.reload('7007721d', component.options)
    }
    module.hot.accept("./ClipboardInput.vue?vue&type=template&id=7007721d&", function () {
      api.rerender('7007721d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/ClipboardInput.vue"
export default component.exports